<template>
  <layouts-header></layouts-header>
  <layouts-sidebar></layouts-sidebar>
  <div class="page-wrapper">
    <div class="content">
      <div class="row">
        <div class="col-md-12">
          <!-- Page Header -->
          <page-header :title="title" />

          <div class="card">
            <!-- Search -->
            <div class="card-header">
              <div v-if="loading" class="loader">Loading...</div>

              <div class="row align-items-center">
                <div class="col-md-3 mb-2">
                  <input
                    type="text"
                    v-model="filters.searchQuery"
                    class="form-control"
                    placeholder="Enter Name here..."
                    @input="onSearch"
                  />
                </div>

                <div class="col-md-3 mb-2">
                  <div
                    class="daterange-picker d-flex align-items-center justify-content-center"
                  >
                    <div class="form-sort me-2">
                      <i class="ti ti-calendar"></i>
                      <input
                        type="text"
                        class="form-control date-range bookingrange"
                        ref="dateRangeInput"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Table -->
            <div class="card-body">
              <div v-if="!isLoading" class="table-responsive custom-table">
                <div class="row mb-2">
                  <div class="col-md-12">
                    <div
                      class="d-flex align-items-center flex-wrap row-gap-3 justify-content-sm-end"
                    >
                      <div>
                        <button
                          class="btn btn-primary me-2"
                          @click="openModal()"
                        >
                          <i class="ti ti-square-rounded-plus me-2"></i>Add New
                        </button>
                      </div>
                      <div class="dropdown me-2 bg-success">
                        <a
                          href="javascript:void(0);"
                          class="dropdown-toggle"
                          data-bs-toggle="dropdown"
                        >
                          <i class="ti ti-package-export me-2"></i>Import/Export
                        </a>
                        <div class="dropdown-menu dropdown-menu-end">
                          <ul>
                            <li>
                              <a
                                href="#"
                                class="dropdown-item"
                                @click="importModal()"
                                ><i
                                  class="ti ti-file-type-xls text-green me-1"
                                ></i
                                >Import as Excel
                              </a>
                            </li>
                            <li>
                              <a
                                href="#"
                                class="dropdown-item"
                                @click="downloadSampleFile()"
                              >
                                <i class="ti ti-download text-blue me-1"></i
                                >Download Sample File
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <a-table
                  class="table"
                  :columns="columns"
                  :data-source="data"
                  :row-selection="rowSelection"
                  row-key="id"
                  :pagination="pagination"
                  :loading="isLoading"
                  @change="handleTableChange"
                >
                  <template #bodyCell="{ column, record }">
                    <template v-if="column.key === 'DOB'">
                      {{ formatDate(record.DOB) }}
                    </template>
                    <template v-if="column.key === 'created_at'">
                      {{ formatDate(record.created_at) }}
                    </template>
                    <template v-if="column.key === 'action'">
                      <div class="dropdown table-action">
                        <a
                          href="#"
                          class="action-icon"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          ><i class="fa fa-ellipsis-v"></i
                        ></a>
                        <div class="dropdown-menu dropdown-menu-right">
                          <a
                            class="dropdown-item"
                            href="#"
                            @click="openModal(record)"
                            ><i class="ti ti-edit text-blue"></i> Edit</a
                          >
                          <a
                            class="dropdown-item"
                            href="#"
                            @click="openDeleteModal(record)"
                            ><i class="ti ti-trash text-danger"></i> Delete</a
                          >
                        </div>
                      </div>
                    </template>
                  </template>
                </a-table>
              </div>

              <div v-else>
                <p>Loading...</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <birthday-import-modal v-if="isShowModal" @refresh="refresh" />
  <birthday-list-modal
    v-if="isAddEditModal"
    @refresh="refresh"
    :isEditMode="isEditMode"
    :title="title"
  />
</template>

<script>
import http from "@/utils/http";
import moment from "moment";
import "daterangepicker/daterangepicker.css";
import "daterangepicker/daterangepicker.js";
import DateRangePicker from "daterangepicker";

export default {
  data() {
    return {
      title: "Birthday List",
      data: [],
      filters: {
        startDate: moment().startOf("month").format("YYYY-MM-DD"),
        endDate: moment().endOf("month").format("YYYY-MM-DD"),
        searchQuery: "",
      },
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "50", "100"],
      },
      selectedRowKeys: [],
      isLoading: false,
      isShowModal: false,
      isEditMode: false,
      isAddEditModal: false,
      columns: [
        {
          title: "ID",
          dataIndex: "id",
          key: "id",
          sorter: (a, b) => a.id - b.id,
          width: "10%",
        },
        {
          title: "Company Name",
          dataIndex: "CompanyName",
          key: "CompanyName",
          sorter: (a, b) => a.CompanyName.localeCompare(b.CompanyName),
          width: "15%",
        },
        {
          title: "Person Name",
          dataIndex: "PersonName",
          key: "PersonName",
          sorter: (a, b) => a.PersonName.localeCompare(b.PersonName),
        },
        {
          title: "Designation",
          dataIndex: "Designation",
          key: "Designation",
          sorter: (a, b) => a.Designation.localeCompare(b.Designation),
        },
        {
          title: "DOB",
          dataIndex: "DOB",
          key: "DOB",
          sorter: (a, b) => a.DOB.localeCompare(b.DOB),
        },
        {
          title: "ContactEmail",
          dataIndex: "ContactEmail",
          key: "ContactEmail",
          sorter: (a, b) => a.ContactEmail.localeCompare(b.ContactEmail),
        },
        {
          title: "ContactNumber",
          dataIndex: "ContactNumber",
          key: "ContactNumber",
          sorter: (a, b) => a.ContactNumber.localeCompare(b.ContactNumber),
        },
        {
          title: "Address",
          dataIndex: "Address",
          key: "Address",
          sorter: (a, b) => a.Address.localeCompare(b.Address),
        },
        {
          title: "Created At",
          dataIndex: "created_at",
          key: "created_at",
          sorter: (a, b) => a.created_at.localeCompare(b.created_at),
        },
        {
          title: "Action",
          key: "action",
        },
      ],
    };
  },
  computed: {
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: (selectedRowKeys) => {
          this.selectedRowKeys = selectedRowKeys;
        },
      };
    },
  },

  mounted() {
    this.getCollections();

    if (this.$refs.dateRangeInput) {
      new DateRangePicker(
        this.$refs.dateRangeInput,
        {
          startDate: moment().startOf("month"),
          endDate: moment().endOf("month"),
          ranges: {
            Today: [moment(), moment()],
            Yesterday: [
              moment().subtract(1, "days"),
              moment().subtract(1, "days"),
            ],
            "Last 7 Days": [moment().subtract(6, "days"), moment()],
            "Last 30 Days": [moment().subtract(29, "days"), moment()],
            "This Month": [moment().startOf("month"), moment().endOf("month")],
            "Last Month": [
              moment().subtract(1, "month").startOf("month"),
              moment().subtract(1, "month").endOf("month"),
            ],
            "All Time": [moment("1970-01-01"), moment()],
          },
        },
        this.booking_range
      );
    }
  },
  methods: {
    booking_range(start, end) {
      this.filters.startDate = start ? start.format("YYYY-MM-DD") : null;
      this.filters.endDate = end ? end.format("YYYY-MM-DD") : null;
      this.onSearch();
      return start.format("M/D/YYYY") + " - " + end.format("M/D/YYYY");
    },
    onSearch() {
      this.pagination.current = 1;
      this.getCollections(this.pagination.current, this.pagination.pageSize);
    },
    openModal(row = "") {
      this.isAddEditModal = true;
      this.isEditMode = !!row.id;
      setTimeout(() => {
        this.$emitter.emit("add-edit-item", row);
      });
    },
    openDeleteModal(row = "") {
      this.isAddEditModal = true;
      setTimeout(() => {
        this.$emitter.emit("delete-item-modal", row);
      });
    },
    async getCollections(page = 1, pageSize = 10) {
      this.isLoading = true;
      try {
        const response = await http.get("birthday-wish-list", {
          params: {
            page,
            per_page: pageSize,
            search: this.filters.searchQuery || undefined,
            start_date: this.filters.startDate,
            end_date: this.filters.endDate,
          },
        });

        this.data = response.data.contents.data;
        this.pagination.total = response.data.contents.total;
        this.pagination.current = response.data.contents.current_page;
        this.pagination.pageSize = response.data.contents.per_page;
      } catch (error) {
        console.error("Error:", error);
        this.isLoading = false;
      } finally {
        this.isLoading = false;
      }
    },
    handleTableChange(pagination) {
      this.getCollections(pagination.current, pagination.pageSize);
    },

    refresh() {
      this.isShowModal = false;
      this.getCollections();
    },
    async downloadSampleFile() {
      try {
        const response = await http.get("/download-sample-birthdaywish");
        const fileUrl = response.data.fileUrl;
        const fileName = response.data.fileName;
        const link = document.createElement("a");
        link.href = fileUrl;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error("Error downloading the file:", error);
      }
    },

    formatDate(date) {
      return moment(date).format("DD-MM-YYYY");
    },

    importModal() {
      this.isShowModal = true;
      this.$nextTick(() => this.$emitter.emit("import-item-modal"));
    },
  },
};
</script>
<style scoped>
.custom-text-truncation {
  list-style-type: none; /* Remove default list styles */
  margin: 0;
  padding: 0;
  width: 100%; /* Ensure the list takes up the full width */
}

.custom-text-truncation li {
  overflow: hidden; /* Hide overflowing content */
  text-overflow: ellipsis; /* Use ellipsis for overflowing text */
  white-space: nowrap; /* Prevent the text from wrapping to the next line */
  display: block; /* Ensure list items are block-level */
  width: 100%; /* Ensure list items are responsive */
  max-width: 100%; /* Prevent content from spilling outside */
}

.custom-text-truncation li span {
  display: inline-block; /* Make sure the span behaves like inline-block */
  max-width: 200px; /* Set a max width to ensure truncation (adjust as needed) */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.form-sort i {
  z-index: unset !important;
}
</style>
